import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import Pagination from '../../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';

const InstituteGradeMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const instituteMasterId = localStorage.getItem("instituteMasterId")

    const initialFormState = [{
        instituteMasterId: '',
        gradeName: []
    }]

    const [GradeData, setGradeData] = useState([])
    const [InstituteGradeData, setInstituteGradeData] = useState([])
    const [admingrades, setAdminGrades] = useState([])
    const [instituteGrades, setInstituteGrades] = useState([])
    const [editId, setEditId] = useState(null)
    const [adminGradeList, setAdminGradeList] = useState([])
    const [error, setError] = useState(null);
    const [instituteError, setInstituteError] = useState([]);
    const [isCheck, setIsCheck] = useState(false);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [gradeNameSort, setGradeNameSort] = useState(null);
    const [dateSort, setDateSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["gradeName", "createdAt"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getInstituteGrade();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setInstituteGrades(await searchArray("I", `/get-institute-grade?instituteMasterId=${instituteMasterId}`, searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(instituteGrades, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(instituteGrades.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > instituteGrades.length) {
            endIndex = instituteGrades.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(instituteGrades.slice(startIndex, endIndex));
    }, [instituteGrades, currPage, itemsPerPage]);

    useEffect(() => {
        const fetchGrade = async () => {
            await getAdminGrade();
            await getInstituteGrade();
        };

        fetchGrade();
    }, []);

    const getAdminGrade = async () => {
        try {
            const apiUrl = `/get-grade-master`;
            const response = await authorizedAxios.get(apiUrl);
            setAdminGrades(response.data.result)
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getInstituteGrade = async () => {
        try {
            const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
            const response = await authorizedAxiosInstitute.get(apiUrl);
            setInstituteGrades(response.data.result);
        } catch (error) {
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.log(errorMsg)
        }
    }

    const isValid = () => {
        let isValid = true;

        if (InstituteGradeData.length > 0) {
            if (InstituteGradeData.some(grade => grade.gradeName.length === 0)) {
                setError(null);
                isValid = false;
            }
        } else if (GradeData.length === 0) {
            setInstituteError(null);
            isValid = false;
        }

        return isValid;
    };

    const addGrade = async () => {
        if (isValid()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-grade`;
                const response = await authorizedAxiosInstitute.post(apiUrl, {
                    instituteMasterId: instituteMasterId,
                    grade: GradeData.concat(InstituteGradeData)
                })
                await getInstituteGrade();
                setGradeData([]);
                setInstituteGradeData([]);

                // setSaveId(response.data.result[0].id);
                setCurrPage(1);
                setGradeNameSort(null);
                setDateSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            if (InstituteGradeData.length > 0) {
                if (InstituteGradeData.some(grade => grade.gradeName.length === 0)) {
                    setError(null);
                    setInstituteError("Class is required");
                }
            } else if (GradeData.length === 0) {
                setError("Class is required");
                setInstituteError(null);
            }
        }
    }

    const deleteGrade = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `delete-institute-grade?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, instituteGrades.length);
                // setRefresh(!refresh);
                await getInstituteGrade();
                setCurrPage(page);
                // setInstituteGrades((prevGrades) => [...prevGrades].filter((grade) => grade.id != id));
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const handleAddGradeSelect = (data) => {
        setGradeData(data.map(i => { return { gradeMasterId: i.value, gradeName: i.label } }))

        if (InstituteGradeData.length > 0 || data.length > 0) {
            setError(null);
        }
    }

    const handleAddLesson = () => {
        setInstituteGradeData((prevData) => (
            [...prevData, {
                gradeMasterId: null,
                gradeName: ""
            }]
        ));
        setError(null);
    };

    useEffect(() => {
        if (isCheck) {
            isValid();
        }
    }, [InstituteGradeData, isCheck])

    const handleInputChange = (e, index) => {
        setInstituteGradeData(prevDataArray => {
            return prevDataArray.map((item, i) => (i === index ? { ...item, gradeName: e.target.value } : item));
        });

        setIsCheck(true);
    }

    const handleRemoveLesson = (index) => {
        setInstituteGradeData(InstituteGradeData.filter((_, i) => i !== index))
    };

    useEffect(() => {
        setAdminGradeList(admingrades.filter(i =>
            !instituteGrades.some(j => i.id == j.gradeMasterId)
        ))
    }, [admingrades, instituteGrades])

    useEffect(() => {
        if (gradeNameSort === true || gradeNameSort === false) {
            setDateSort(null);
        }
    }, [gradeNameSort])

    useEffect(() => {
        if (dateSort === true || dateSort === false) {
            setGradeNameSort(null);
        }
    }, [dateSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Class Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-graduation-cap"></i>Class Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={GradeData?.map((i) => {
                                                            if (i.gradeMasterId && i.gradeName) {
                                                                return {
                                                                    value: i.gradeMasterId,
                                                                    label: i.gradeName
                                                                }
                                                            }
                                                        })}
                                                        name="state"
                                                        isMulti
                                                        options={adminGradeList?.map((i) => {
                                                            return {
                                                                value: i.id,
                                                                label: i.gradeName
                                                            }
                                                        })}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={(data) => handleAddGradeSelect(data)}
                                                    />
                                                    {error && <p style={{ color: 'red' }}>{error}</p>}
                                                </div>
                                                {InstituteGradeData?.map((grade, index) => (
                                                    <>
                                                        <div className="col-md-5">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Class Name :</label>
                                                            <input type="text" className="form-control" id={`lessonName${index}`} name='gradeName' onChange={(e) => handleInputChange(e, index)} value={grade.gradeName} />
                                                            {instituteError && grade.gradeName == "" && <p style={{ color: 'red' }}>{instituteError}</p>}
                                                        </div>
                                                        <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                            <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveLesson(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                        </div>
                                                    </>
                                                ))}

                                                <div className="col-md-12 mt-4 mb-1">
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ width: '233px' }} onClick={handleAddLesson}>+ Add Another Class Name</button>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" style={{ marginRight: "20px" }} type="button" onClick={addGrade}>Save</button>
                                                        }
                                                        <button className="btn btn-danger delete_icon" style={{ marginRight: "20px" }} type="button" onClick={() => { setGradeData(initialFormState); setEditId(''); /*setInstituteGrades([]);*/ setInstituteGradeData([]); setError(null); setInstituteError(null) }}>Reset</button>

                                                        {/* {
                                                            editId && (<button className="btn btn-success" type="button" onClick={updateGrade} disabled={!editId}>Update</button>)
                                                        } */}
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Sr. No.</th>
                                                                        <th scope="col">
                                                                            Class Name
                                                                            <SortIcon sortState={gradeNameSort} setSortState={setGradeNameSort} setData={setInstituteGrades} setCurrPage={setCurrPage} sortingPath={"gradeName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Date
                                                                            <SortIcon sortState={dateSort} setSortState={setDateSort} setData={setInstituteGrades} setCurrPage={setCurrPage} sortingPath={"createdAt"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((grade, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row">{startIndex + index + 1}</th>
                                                                                        <td>{grade.gradeName}</td>
                                                                                        <td>{grade.createdAt.split(",")[0]}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button"
                                                                                                onClick={() => deleteGrade(grade.id)}

                                                                                            > <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Class Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={instituteGrades.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteGradeMaster;